import { render } from "./AudiAnswer.vue?vue&type=template&id=616816a6"
import script from "./AudiAnswer.vue?vue&type=script&lang=js"
export * from "./AudiAnswer.vue?vue&type=script&lang=js"

import "./AudiAnswer.vue?vue&type=style&index=0&id=616816a6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__